// custom_script.js

let uploadedImageUrl = null;
let upload_id = null;
// Global variable to track the currently selected image
let currentSelectedImage = null;
let fullTemplateData = []; // will hold all templates from API globally

// Global variables to store current descriptions
let currentDescriptionStyle = '';
let currentDescriptionSubject = '';
let currentDescriptionBackground = '';
let currentDescriptionAction = '';

// Function Definitions

/**
 * Parses the `prompt_final` string into an object containing `style`, `subject`, `background`, and `action`.
 * @param {string} promptFinal - The prompt_final string from the API.
 * @returns {Object} An object with keys: style, subject, background, action.
 */
function parsePromptFinal(promptFinal) {
  const details = {};

  if (!promptFinal || typeof promptFinal !== 'string') {
    console.warn('Invalid prompt_final:', promptFinal);
    return details;
  }

  // Split the string by semicolons to separate each key-value pair
  const parts = promptFinal.split(';');

  parts.forEach(part => {
    // Split each part by the first colon to separate key and value
    const [key, ...valueParts] = part.split(':');

    if (key && valueParts.length > 0) {
      const value = valueParts.join(':').trim(); // Rejoin in case ':' exists in the value
      details[key.trim().toLowerCase()] = value;
    }
  });

  return details;
}

async function fetchFullTemplateData() {
  const url = "https://makcacakir.pythonanywhere.com/select_carousel";
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    fullTemplateData = await response.json();
    console.log('Loaded full template data:', fullTemplateData);

    // Load default filter on page load, e.g. 'pet'
    loadTemplatesByFilter('pet');
  } catch (error) {
    console.error('Error loading templates:', error);
  }
}

function loadTemplatesByFilter(filterType) {
  const styleCarousel = document.getElementById('style-carousel');
  if (!styleCarousel) return;

  // Keep only the first child (the hidden No Style item)
  const noStyleItem = styleCarousel.querySelector('.carousel-item');
  styleCarousel.innerHTML = '';
  if (noStyleItem) {
    styleCarousel.appendChild(noStyleItem);
  }

  // Filter templates by type
  const filtered = fullTemplateData.filter(item => item.type === filterType);

  if (filtered.length === 0) {
    const msg = document.createElement('p');
    msg.textContent = `No templates found for type "${filterType}".`;
    msg.style.color = 'red';
    styleCarousel.appendChild(msg);
    return;
  }

  filtered.forEach((item, index) => {
    const imageUrl = item.imageUrl || '';
    const details = parsePromptFinal(item.prompt_final || '');

    const carouselItem = document.createElement('div');
    carouselItem.className = 'carousel-item';

    const img = document.createElement('img');
    img.className = 'carousel-image';
    img.src = imageUrl;
    img.alt = `Template ${index + 1}`;
    img.setAttribute('data-style', details.style || '');
    img.setAttribute('data-subject', details.subject || '');
    img.setAttribute('data-background', details.background || '');
    img.setAttribute('data-action', details.action || '');

    carouselItem.appendChild(img);
    styleCarousel.appendChild(carouselItem);
  });

  // Auto-select the first filtered template (after No Style)
  const styleImages = styleCarousel.querySelectorAll('.carousel-image');
  if (styleImages.length > 1) {
    // Deselect all
    styleImages.forEach(img => img.classList.remove('selected'));

    // Select first filtered (skip No Style at 0)
    const firstTemplate = styleImages[1];
    firstTemplate.classList.add('selected');

    // Fill description fields
    document.getElementById('style').value = firstTemplate.getAttribute('data-style') || '';
    // document.getElementById('subject').value = firstTemplate.getAttribute('data-subject') || '';
    const isSquare = document
      .querySelector('input[name="orientation"]:checked')
      .value
      .startsWith('Square');
    
    if (!isSquare) {
      document.getElementById('subject').value = firstTemplate.dataset.subject || '';
    } 
    // else do nothing (leave whatever placeholder or note you’ve set)

    document.getElementById('background').value = firstTemplate.getAttribute('data-background') || '';
    document.getElementById('action').value = firstTemplate.getAttribute('data-action') || '';

    ['style', 'background', 'action'].forEach(id => {
      const field = document.getElementById(id);
      if (field) field.dispatchEvent(new Event('input'));
    });

    currentSelectedImage = firstTemplate;
  }
}

function handleFilterClick(event) {
  const target = event.target;
  if (!target.classList.contains('filter-option')) return;

  // Update filter carousel selection UI
  document.querySelectorAll('#filter-carousel .filter-option').forEach(img => {
    img.style.borderColor = 'transparent';
    img.classList.remove('selected');
  });
  target.style.borderColor = '#5cb85c';
  target.classList.add('selected');

  // Load filtered templates into style-carousel
  const filterType = target.getAttribute('data-filter-type');
  loadTemplatesByFilter(filterType);
}


/**
 * Fetches templates from the select_carousel API and populates the style-carousel.
 */
async function fetchAndPopulateStyleCarousel() {
  const url = "https://makcacakir.pythonanywhere.com/select_carousel";
  console.log(`Fetching templates from ${url}`);

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();
    console.log('Fetched style carousel data:', data);

    // Filter data by type = 'pet'
    data = data.filter(item => item.type === 'pet');

    const styleCarousel = document.getElementById('style-carousel');

    if (!styleCarousel) {
      throw new Error("Style carousel container with ID 'style-carousel' not found.");
    }

    if (Array.isArray(data) && data.length > 0) {
      data.forEach((item, index) => {
        const imageUrl = item.imageUrl || '';
        const promptFinal = item.prompt_final || '';

        console.log(`Processing Template ${index + 1}:`, item);

        // Parse prompt_final to extract details
        const details = parsePromptFinal(promptFinal);
        console.log(`Parsed details for Template ${index + 1}:`, details);

        const style = details.style || '';
        const subject = details.subject || '';
        const background = details.background || '';
        const action = details.action || '';

        // Create carousel-item div
        const carouselItem = document.createElement('div');
        carouselItem.className = 'carousel-item';

        // Create img element with data attributes
        const img = document.createElement('img');
        img.className = 'carousel-image';
        img.src = imageUrl;
        img.alt = `Template ${index + 1}`;
        img.setAttribute('data-style', style);
        img.setAttribute('data-subject', subject);
        img.setAttribute('data-background', background);
        img.setAttribute('data-action', action);

        // Append img to carousel-item
        carouselItem.appendChild(img);

        // Append carousel-item to style-carousel
        styleCarousel.appendChild(carouselItem);

        console.log(`Appended Template ${index + 1} to style-carousel.`);
      });

      console.log('Style carousel populated dynamically.');

      // Auto-select first real template (after No Style) and fill fields
      const styleCarouselImages = document.querySelectorAll('#style-carousel .carousel-image');
      if (styleCarouselImages.length > 1) {
        // Deselect all
        styleCarouselImages.forEach(img => img.classList.remove('selected'));

        const firstTemplate = styleCarouselImages[1]; // Skip the default 'No Style'
        firstTemplate.classList.add('selected');

        // Extract data attributes
        const style = firstTemplate.getAttribute('data-style') || '';
        const background = firstTemplate.getAttribute('data-background') || '';
        const action = firstTemplate.getAttribute('data-action') || '';

        // Populate the fields
        document.getElementById('style').value = style;
        document.getElementById('background').value = background;
        document.getElementById('action').value = action;

        // Trigger auto-resize
        ['style', 'background', 'action'].forEach(id => {
          const field = document.getElementById(id);
          if (field) field.dispatchEvent(new Event('input'));
        });

        console.log('✅ Auto-selected first template and populated description fields.');
      }

    } else {
      console.warn('No templates available from select_carousel API.');
      const noTemplatesMessage = document.createElement('p');
      noTemplatesMessage.textContent = 'No templates available.';
      noTemplatesMessage.style.color = 'red';
      styleCarousel.appendChild(noTemplatesMessage);
    }

  } catch (error) {
    console.error('Error fetching style carousel data:', error);

    // Display error message to the user
    const styleCarousel = document.getElementById('style-carousel');
    if (styleCarousel) {
      const errorMessage = document.createElement('p');
      errorMessage.textContent = 'Failed to load templates.';
      errorMessage.style.color = 'red';
      styleCarousel.appendChild(errorMessage);
    }

    alert('Error loading templates. Please try again later.');
  }
}


/**
 * Fetches recent images from the recent_images API and populates the result-carousel.
 */
function fetchAndPopulateCarousel() {
  const url = 'https://makcacakir.pythonanywhere.com/recent_images';
  console.log(`Fetching recent images from ${url}`);

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Fetched recent images data:', data);

      if (!Array.isArray(data) || data.length === 0) {
        console.warn('No recent images received from the API.');
        return;
      }

      data.forEach((item, index) => {
        appendImageToCarousel(item.imageUrl, item.orientation, item.prompt_final, false);
      });

      // Automatically select the first image
      const firstImage = document.querySelector('#result-carousel .carousel-image');
      if (firstImage) {
        firstImage.classList.add('selected');
        const firstImageUrl = firstImage.getAttribute('data-image-url');
        const firstImageOrientation = firstImage.getAttribute('data-orientation');
        updatePurchaseButton(firstImageUrl, firstImageOrientation);
        movePurchaseButtonBelow(firstImage);
      }
    })
    .catch(error => {
      console.error('Error fetching recent images:', error);
      alert('Error loading recent images. Please try again later.');
    });
}

/**
 * Creates and appends (or prepends) an image to the specified carousel.
 * @param {string} imageUrl - URL of the image to display.
 * @param {string} orientation - Orientation of the image (e.g., Portrait, Landscape, Square).
 * @param {string} promptFinal - Description associated with the image.
 * @param {boolean} prepend - If true, prepends the image to the carousel; otherwise, appends.
 */
function appendImageToCarousel(imageUrl, orientation, promptFinal, prepend = false) {
  const carouselContainer = document.getElementById('result-carousel'); // Targeting "Recent Images" carousel
  if (!carouselContainer) {
    console.error("Carousel container with ID 'result-carousel' not found.");
    return;
  }

  // Create carousel-item div
  const carouselItem = document.createElement('div');
  carouselItem.className = 'carousel-item';

  // Create prompt-text div (hidden by default)
  const promptTextDiv = document.createElement('div');
  promptTextDiv.className = 'prompt-text';
  promptTextDiv.textContent = `"${promptFinal}"`;

  // Create img element
  const img = document.createElement('img');
  img.className = 'carousel-image';
  img.src = imageUrl;
  img.alt = 'Generated Image';
  img.setAttribute('data-orientation', orientation);
  img.setAttribute('data-image-url', imageUrl);
  img.loading = 'lazy';

  // Append elements to carousel-item
  carouselItem.appendChild(promptTextDiv);
  carouselItem.appendChild(img);

  // Prepend or append the carousel-item
  if (prepend) {
    carouselContainer.insertBefore(carouselItem, carouselContainer.firstChild);
  } else {
    carouselContainer.appendChild(carouselItem);
  }

  console.log(`Image ${prepend ? "prepended" : "appended"} to carousel: ${promptFinal}`);
}

/**
 * Updates the Purchase Button's URL based on the selected image.
 * @param {string} imageUrl - URL of the selected image.
 * @param {string} orientation - Orientation of the selected image.
 */
function updatePurchaseButton(imageUrl, orientation) {
  const purchaseButton = document.getElementById('purchaseButton');
  if (!purchaseButton) {
    console.error("Purchase button with ID 'purchaseButton' not found.");
    return;
  }

  const orientationKey = orientation.split(' ')[0].toLowerCase();
  const uniqueImageUrl = imageUrl;
  const encodedImageUrl = encodeURIComponent(uniqueImageUrl);

  // Get stored unique device ID or generate one
  let deviceId = localStorage.getItem('uniqueDeviceId');
  if (!deviceId) {
    deviceId = generateUniqueDeviceId();
    localStorage.setItem('uniqueDeviceId', deviceId);
    console.log('Generated and stored new unique device ID:', deviceId);
  }

  // Construct product page URL
  const productPageUrlWithImage = `/products/custom-canvas-${orientationKey}?device_id=${deviceId}&image_url=${encodedImageUrl}`;

  purchaseButton.style.display = 'block';
  
  // purchaseButton.onclick = function () {
  //   window.location.href = productPageUrlWithImage;
  // };

  purchaseButton.onclick = function () {
  gtag_report_conversion(productPageUrlWithImage);
  };

  console.log(`Purchase button updated for image: ${imageUrl}`);
}

/**
 * Moves the Purchase Button below the selected image in the carousel.
 * @param {HTMLElement} selectedImage - The image element that was selected.
 */
function movePurchaseButtonBelow(selectedImage) {
  const purchaseButton = document.getElementById('purchaseButton');
  if (!purchaseButton) {
    console.error("Purchase button with ID 'purchaseButton' not found.");
    return;
  }

  purchaseButton.style.display = 'block';
  selectedImage.parentNode.insertBefore(purchaseButton, selectedImage.nextSibling);

  console.log('Moved purchase button below the selected image.');
}

/**
 * Generates a unique device ID.
 * @returns {string} A unique device identifier.
 */
function generateUniqueDeviceId() {
  // Simple UUID generator
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Handles the submission of the image generation form.
 * @param {Event} event - The form submission event.
 */
async function handleFormSubmit(event) {
  event.preventDefault();

  // 1) Ensure an image is uploaded
  if (!uploadedImageUrl) {
    const noImageModal = document.getElementById('noImageModal');
    if (noImageModal) noImageModal.style.display = 'flex';
    return;
  }

  // 2) Show loading overlay
  const loadingOverlay = document.getElementById('loadingOverlay');
  if (loadingOverlay) loadingOverlay.style.display = 'flex';

  try {
    // 3) Read selected style
    const selectedStyleElement = document.querySelector('.carousel-image.selected');
    const selectedStyle = selectedStyleElement
      ? selectedStyleElement.getAttribute('data-style') || ''
      : '';

    // 4) Read selected orientation
    const orientationElement = document.querySelector('input[name="orientation"]:checked');
    const selectedOrientation = orientationElement ? orientationElement.value : '';

    // 5) Collect description field values
    const styleDescription      = document.getElementById('style').value.trim();
    const subjectDescription    = document.getElementById('subject').value.trim();
    const backgroundDescription = document.getElementById('background').value.trim();
    const actionDescription     = document.getElementById('action').value.trim();

    // 6) Build the `details` string, omitting subject if square
    const isSquare = selectedOrientation.startsWith('Square');
    const parts = [
      `style: ${styleDescription}`,
      ...(!isSquare && subjectDescription ? [`subject: ${subjectDescription}`] : []),
      `background: ${backgroundDescription}`,
      `action: ${actionDescription}`
    ];
    const details = parts.join('; ');

    // 7) Prepare request body
    const deviceId = localStorage.getItem('uniqueDeviceId') || generateUniqueDeviceId();
    const requestBody = {
      style:       selectedStyle,
      details:     details,
      orientation: selectedOrientation,
      image_url:   uploadedImageUrl,
      device_id:   deviceId,
      watermark:   1
    };

    console.log('Submitting Request:', requestBody);

    // 8) Call the image_edit API
    const response = await fetch('https://makcacakir.pythonanywhere.com/image_edit', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error: ${response.status} – ${errorText}`);
    }

    const data = await response.json();
    if (data.error) {
      throw new Error(data.error);
    }

    // 9) Update the UI with the generated image
    const promptFinalText = data.prompt_final || '';
    appendImageToCarousel(data.imageUrl, selectedOrientation, promptFinalText, true);

    // 10) Auto-select and move purchase button
    const firstImage = document.querySelector('#result-carousel .carousel-image');
    if (firstImage) {
      document.querySelectorAll('#result-carousel .carousel-image').forEach(img => img.classList.remove('selected'));
      firstImage.classList.add('selected');
      const imgUrl = firstImage.getAttribute('data-image-url');
      const imgOri = firstImage.getAttribute('data-orientation');
      updatePurchaseButton(imgUrl, imgOri);
      movePurchaseButtonBelow(firstImage);
    }

    // 11) Scroll into view
    document.getElementById('result-carousel')
            .scrollIntoView({ behavior: 'smooth', block: 'start' });

  } catch (err) {
    console.error('Fetch error:', err);
    alert(`❌ ${err.message}`);
  } finally {
    // 12) Hide loading overlay
    if (loadingOverlay) loadingOverlay.style.display = 'none';
  }
}


/**
 * Opens the upload modal.
 */
function openUploadModal() {
  const modal = document.getElementById('uploadModal');
  if (modal) {
    modal.style.display = 'flex';
    console.log('Upload modal opened.');
  }
}

/**
 * Closes the upload modal.
 */
function closeUploadModal() {
  const modal = document.getElementById('uploadModal');
  if (modal) {
    modal.style.display = 'none';
    console.log('Upload modal closed.');
  }
}

/**
 * Opens the reset confirmation modal.
 */
function openResetModal() {
  const resetModal = document.getElementById('resetModal');
  if (resetModal) {
    resetModal.style.display = 'flex';
    console.log('Reset modal opened.');
  }
}

/**
 * Closes the reset confirmation modal.
 */
function closeResetModal() {
  const resetModal = document.getElementById('resetModal');
  if (resetModal) {
    resetModal.style.display = 'none';
    console.log('Reset modal closed.');
  }
}

/**
 * Resets the description fields in the form.
 */
function resetDescriptions() {
  document.getElementById('style').value = '';
  document.getElementById('subject').value = '';
  document.getElementById('background').value = '';
  document.getElementById('action').value = '';

  // Trigger auto-resize for all textareas
  autoResize.call(document.getElementById('style'));
  autoResize.call(document.getElementById('subject'));
  autoResize.call(document.getElementById('background'));
  autoResize.call(document.getElementById('action'));

  console.log('Description fields have been reset.');

  closeResetModal();
}

/**
 * Opens the Copy Descriptions modal with the provided descriptions.
 * All checkboxes are unchecked by default, and only enabled if a description exists.
 * @param {string} style - Style description.
 * @param {string} subject - Subject description.
 * @param {string} background - Background description.
 * @param {string} action - Action description.
 */
function openCopyDescriptionsModal(style, subject, background, action) {
  // store for later copyDescriptions()
  currentDescriptionStyle     = style;
  currentDescriptionSubject   = subject;
  currentDescriptionBackground= background;
  currentDescriptionAction    = action;

  const modal = document.getElementById('copyDescriptionsModal');
  if (!modal) return;

  // figure out if we're in Square mode right now
  const orientationValue = document.querySelector('input[name="orientation"]:checked').value;
  const isSquare = orientationValue.startsWith('Square');

  // grab all 4 checkboxes
  const copyStyle      = document.getElementById('copyStyle');
  const copySubject    = document.getElementById('copySubject');
  const copyBackground = document.getElementById('copyBackground');
  const copyAction     = document.getElementById('copyAction');

  // Style checkbox: enable if there's a style to copy
  if (style) {
    copyStyle.checked  = true;
    copyStyle.disabled = false;
  } else {
    copyStyle.checked  = false;
    copyStyle.disabled = true;
  }

  // Subject (Text) checkbox: 
  //   • always disabled in Square mode
  //   • otherwise enable only if a subject exists
  if (isSquare) {
    copySubject.checked  = false;
    copySubject.disabled = true;
  } else if (subject) {
    copySubject.checked  = true;
    copySubject.disabled = false;
  } else {
    copySubject.checked  = false;
    copySubject.disabled = true;
  }

  // Background checkbox
  if (background) {
    copyBackground.checked  = true;
    copyBackground.disabled = false;
  } else {
    copyBackground.checked  = false;
    copyBackground.disabled = true;
  }

  // Action checkbox
  if (action) {
    copyAction.checked  = true;
    copyAction.disabled = false;
  } else {
    copyAction.checked  = false;
    copyAction.disabled = true;
  }

  // show the modal
  modal.style.display = 'flex';
}


/**
 * Closes the Copy Descriptions modal.
 */
function closeCopyDescriptionsModal() {
  const modal = document.getElementById('copyDescriptionsModal');
  if (modal) {
    modal.style.display = 'none';
    console.log('Copy Descriptions modal closed.');
  }
}

/**
 * Copies the selected descriptions to their respective textareas.
 */
function copyDescriptions() {
  const copyStyle = document.getElementById('copyStyle').checked;
  const copySubject = document.getElementById('copySubject').checked;
  const copyBackground = document.getElementById('copyBackground').checked;
  const copyAction = document.getElementById('copyAction').checked;

  // Update description fields based on selected checkboxes using global variables
  if (copyStyle) {
    document.getElementById('style').value = currentDescriptionStyle || '';
    autoResize.call(document.getElementById('style'));
    console.log('Style description copied to textarea.');
  }

  if (copySubject) {
    document.getElementById('subject').value = currentDescriptionSubject || '';
    autoResize.call(document.getElementById('subject'));
    console.log('Subject description copied to textarea.');
  }

  if (copyBackground) {
    document.getElementById('background').value = currentDescriptionBackground || '';
    autoResize.call(document.getElementById('background'));
    console.log('Background description copied to textarea.');
  }

  if (copyAction) {
    document.getElementById('action').value = currentDescriptionAction || '';
    autoResize.call(document.getElementById('action'));
    console.log('Action description copied to textarea.');
  }

  // ✅ Sync dataset values of the currently selected image
  if (currentSelectedImage) {
    if (copyStyle) currentSelectedImage.setAttribute('data-style', currentDescriptionStyle || '');
    if (copySubject) currentSelectedImage.setAttribute('data-subject', currentDescriptionSubject || '');
    if (copyBackground) currentSelectedImage.setAttribute('data-background', currentDescriptionBackground || '');
    if (copyAction) currentSelectedImage.setAttribute('data-action', currentDescriptionAction || '');
    console.log('Updated data attributes of the selected image.');
  }

  // Close the modal after copying
  closeCopyDescriptionsModal();
}

/**
 * Generates and auto-resizes the height of a textarea based on its content.
 */
function autoResize() {
  this.style.height = 'auto';
  this.style.height = `${this.scrollHeight}px`;
}

/**
 * Handles the selection of carousel images and manages related interactions.
 * Uses event delegation to handle dynamically added images.
 * @param {Event} event - The click event.
 */
function handleCarouselClick(event) {
  const target = event.target;
  if (target.classList.contains('carousel-image')) {
    // Determine which carousel was clicked
    const carouselContainer = target.parentNode.parentNode;
    const carouselId = carouselContainer.id;

    // Deselect all images within the same carousel
    carouselContainer.querySelectorAll('.carousel-image.selected').forEach(img => img.classList.remove('selected'));

    // Select the clicked image
    target.classList.add('selected');
    console.log(`Carousel image selected: ${target.alt}`);

    // Update the global variable with the currently selected image
    currentSelectedImage = target;

    if (carouselId === 'style-carousel') {
      // Get individual data attributes
      const style = target.getAttribute('data-style');
      const subject = target.getAttribute('data-subject');
      const background = target.getAttribute('data-background');
      const action = target.getAttribute('data-action');

      console.log('Selected style details:', { style, subject, background, action });

      // Check if the selected image is the first one (No Style)
      if (style === "" && subject === "" && background === "" && action === "") {
        // Open the reset modal without clearing the fields
        openResetModal();
      } else {
        // Open the Copy Descriptions Modal with the selected style's descriptions
        openCopyDescriptionsModal(style, subject, background, action);
      }
    }

    if (carouselId === 'result-carousel') {
      const selectedImageUrl = target.getAttribute('data-image-url');
      const selectedOrientation = target.getAttribute('data-orientation');
      updatePurchaseButton(selectedImageUrl, selectedOrientation);
      movePurchaseButtonBelow(target);
    }
  }
}

// ──────────────────────────────────────────────────────────────────────────────
//  DOMContentLoaded  ▸  initialise everything once the HTML is ready
// ──────────────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  /* grab textarea elements once */
  const styleTextarea      = document.getElementById('style');
  const subjectTextarea    = document.getElementById('subject');
  const backgroundTextarea = document.getElementById('background');
  const actionTextarea     = document.getElementById('action');

  // 1️⃣  FILTER-CAROUSEL  (pet / dad / mom …)  ────────────────────────────────
  document.querySelectorAll('#filter-carousel .filter-option')
          .forEach(img => img.addEventListener('click', handleFilterClick));

  // 2️⃣  STYLE-CAROUSEL  (individual templates)  ──────────────────────────────
  document.getElementById('style-carousel').addEventListener('click', event => {
    const target = event.target;
    if (!target.classList.contains('carousel-image')) return;

    // deselect siblings & mark this one
    target.parentElement.parentElement
          .querySelectorAll('.carousel-image.selected')
          .forEach(img => img.classList.remove('selected'));
    target.classList.add('selected');
    currentSelectedImage = target;

    // save its descriptions for the Copy-modal
    currentDescriptionStyle      = target.dataset.style      || '';
    currentDescriptionSubject    = target.dataset.subject    || '';
    currentDescriptionBackground = target.dataset.background || '';
    currentDescriptionAction     = target.dataset.action     || '';

    openCopyDescriptionsModal(
      currentDescriptionStyle,
      currentDescriptionSubject,
      currentDescriptionBackground,
      currentDescriptionAction
    );
  });

  // 3️⃣  RESULT-CAROUSEL click (select generated image)  ──────────────────────
  document.getElementById('result-carousel')
          .addEventListener('click', handleCarouselClick);

  // 4️⃣  SYNC user edits → template data-attributes  ──────────────────────────
  ['style', 'subject', 'background', 'action'].forEach(id => {
    const field = document.getElementById(id);
    field.addEventListener('input', e => {
      // auto-resize
      field.style.height = 'auto';
      field.style.height = `${field.scrollHeight}px`;

      // copy into currently-selected template (if any)
      if (currentSelectedImage) {
        currentSelectedImage.dataset[id] = e.target.value.trim();
      }
    });
    // initialise height
    field.dispatchEvent(new Event('input'));
  });

  // 5️⃣  ORIENTATION radio – enable / disable the “subject” textarea
  document.querySelectorAll('input[name="orientation"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const isSquare = radio.value.startsWith('Square');
      subjectTextarea.disabled     = isSquare;
      subjectTextarea.value        = isSquare ? '' : subjectTextarea.value;
      subjectTextarea.placeholder  = isSquare
        ? 'Text on image only in portrait or landscape shapes'
        : 'Text to be shown on image';

      // when disabled, also disable the Copy-modal’s Subject checkbox
      const copySubjectCheckbox = document.getElementById('copySubject');
      copySubjectCheckbox.disabled = isSquare;
      if (isSquare) copySubjectCheckbox.checked = false;
    });
  });
  // trigger once for initial state
  document.querySelector('input[name="orientation"]:checked')
          .dispatchEvent(new Event('change'));

  // 6️⃣  FORM SUBMIT – nothing overwritten anymore  ───────────────────────────
  document.getElementById('image-generation-form')
          .addEventListener('submit', handleFormSubmit);

  // 7️⃣  General modal / upload / reset / copy listeners  ─────────────────────
  initializeEventListeners();          // your helper that wires the rest
  fetchAndPopulateCarousel();          // “Recent Images”
  fetchFullTemplateData();             // all templates, then loadTemplatesByFilter('pet')
  generateAndStoreDeviceId();          // unique visitor ID

  console.log('✅ DOMContentLoaded initialisation complete');
});



/**
 * Handles file selection from gallery or camera uploads.
 * Only uploads the image and returns the URL—no describe call.
 */
async function handleFileSelect(event, source) {
  const selectedFile = event.target.files[0];
  if (!selectedFile) return; // user cancelled

  const loadingOverlay = document.getElementById('loadingOverlay');
  if (loadingOverlay) loadingOverlay.style.display = 'flex';

  try {
    // 1) Upload the image
    const formData = new FormData();
    formData.append('file', selectedFile);

    const uploadResponse = await fetch('https://makcacakir.pythonanywhere.com/uploadfile_v2', {
      method: 'POST',
      body: formData
    });

    if (!uploadResponse.ok) {
      const errorText = await uploadResponse.text();
      throw new Error(`Upload failed: ${uploadResponse.statusText} - ${errorText}`);
    }

    // 2) Extract and return the uploaded image URL
    const { image_url: imageUrl } = await uploadResponse.json();
    if (!imageUrl) throw new Error('No image_url returned from upload.');

    uploadedImageUrl = imageUrl;  // Store globally
    
    // ✅ Show preview
    const previewImg = document.getElementById('preview-img');
    const previewText = document.getElementById('preview-text');
    const previewContainer = document.getElementById('uploaded-image-preview');
    
    if (previewImg && previewContainer) {
      previewImg.src = imageUrl;
      previewImg.style.display = 'block'; // Show image
      previewContainer.style.display = 'flex'; // Show container
    }
    
    if (previewText) {
      previewText.style.display = 'block'; // Make sure the text also shows
    }

    console.log('✅ Image uploaded');
    openUploadSuccessModal();

    // Close the modal so the user can continue filling in descriptions manually
    closeUploadModal();

    // Optionally: if you want to preview the image,
    // you could insert an <img src="${imageUrl}"> somewhere here.

  } catch (err) {
    console.error('Upload error:', err);
    alert(`Upload error: ${err.message}`);
  } finally {
    if (loadingOverlay) loadingOverlay.style.display = 'none';
    event.target.value = ''; // reset file input
  }
}


/**
 * Initializes all necessary event listeners for user interactions.
 */
function initializeEventListeners() {
  // Auto-resize textareas on input
  const textareas = document.querySelectorAll('textarea');
  textareas.forEach(textarea => {
    textarea.addEventListener('input', autoResize, false);
    autoResize.call(textarea); // Initialize size
  });

  // 📸 Camera icon opens upload modal
  const cameraIcon = document.querySelector('.camera-icon.upload-photo');
  if (cameraIcon) {
    cameraIcon.addEventListener('click', openUploadModal);
    console.log('Camera icon event listener attached.');
  }

  // ❌ Modal close buttons
  const closeButtons = document.querySelectorAll('.close-button');
  closeButtons.forEach(button => {
    button.addEventListener('click', function () {
      const modal = button.closest('.modal');
      if (modal) {
        modal.style.display = 'none';
        console.log('Modal closed via close button.');
      }
    });
  });

  // 📁 Trigger file inputs from gallery/camera buttons
  const triggerGalleryButtons = document.querySelectorAll('.trigger-gallery');
  triggerGalleryButtons.forEach(button => {
    button.addEventListener('click', function () {
      document.getElementById('customImageGallery').click();
      console.log('Gallery upload triggered.');
    });
  });

  const triggerCameraButtons = document.querySelectorAll('.trigger-camera');
  triggerCameraButtons.forEach(button => {
    button.addEventListener('click', function () {
      document.getElementById('customImageCamera').click();
      console.log('Camera upload triggered.');
    });
  });

  // ✅ Upload success modal OK button
  const uploadSuccessOk = document.getElementById('uploadSuccessOk');
  if (uploadSuccessOk) {
    uploadSuccessOk.addEventListener('click', closeUploadSuccessModal);
  }

  // 🔁 Reset button
  const resetButtons = document.querySelectorAll('.reset-button');
  resetButtons.forEach(button => {
    button.addEventListener('click', resetDescriptions);
    console.log('Reset button event listener attached.');
  });

  // 📋 Copy description button
  const copyButtons = document.querySelectorAll('.copy-button');
  copyButtons.forEach(button => {
    button.addEventListener('click', copyDescriptions);
    console.log('Copy button event listener attached.');
  });

  // after you've grabbed `orientation` radios…
  const subjectField = document.getElementById('subject');
  const subjectWrapper = subjectField.closest('.description-field');
  const subjectNote = document.createElement('small');
  subjectNote.style.display = 'block';
  subjectNote.style.color = '#666';
  subjectNote.style.fontSize = '12px';
  subjectWrapper.appendChild(subjectNote);
  
  // inside initializeEventListeners(), in your orientation change listener:
  document.querySelectorAll('input[name="orientation"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const isSquare = radio.value.startsWith('Square');
      // Disable/enable subject textarea
      subjectField.disabled = isSquare;
      subjectField.value    = '';
      subjectField.placeholder = isSquare
        ? 'Text on image only in portrait or landscape shapes'
        : 'Text to be shown on image';
  
      // Also disable & uncheck the "copySubject" checkbox
      const copySubjectCheckbox = document.getElementById('copySubject');
      copySubjectCheckbox.disabled = isSquare;
      copySubjectCheckbox.checked  = false;
  
    });
  });
  
  // trigger initial state
  document.querySelector('input[name="orientation"]:checked')
          .dispatchEvent(new Event('change'));



  // ❌ Cancel buttons for modals
  const cancelButtons = document.querySelectorAll('.cancel-button');
  cancelButtons.forEach(button => {
    button.addEventListener('click', function () {
      const modal = button.closest('.modal');
      if (modal) {
        modal.style.display = 'none';
        console.log('Modal closed via cancel button.');
        if (modal.id === 'copyDescriptionsModal' && currentSelectedImage) {
          currentSelectedImage.classList.remove('selected');
          currentSelectedImage = null;
          console.log('Image deselected after cancel.');
        }
      }
    });
  });

  // 🖼 Carousel image click
  document.querySelectorAll('.carousel-container').forEach(container => {
    container.addEventListener('click', handleCarouselClick);
  });

  // ✍️ Form submission
  const imageForm = document.getElementById('image-generation-form');
  if (imageForm) {
    imageForm.addEventListener('submit', handleFormSubmit);
    console.log('Image generation form submit event listener attached.');
  }

  // ⚠️ No image uploaded modal
  const noImageOk = document.getElementById('noImageOk');
  const noImageModal = document.getElementById('noImageModal');
  if (noImageOk && noImageModal) {
    noImageOk.addEventListener('click', () => {
      noImageModal.style.display = 'none';
    });

    const closeNoImage = noImageModal.querySelector('.close-button');
    if (closeNoImage) {
      closeNoImage.addEventListener('click', () => {
        noImageModal.style.display = 'none';
      });
    }
  }

  console.log('All event listeners initialized.');
}


/**
 * Handles clicks outside of modals to close them.
 * @param {Event} event - The window click event.
 */
function handleWindowClick(event) {
  const modals = document.querySelectorAll('.modal');
  modals.forEach(modal => {
    if (event.target === modal) {
      modal.style.display = "none";
      console.log('Modal closed by clicking outside.');

      // Additional logic can be added here if needed
    }
  });
}

/**
 * Generates a unique device ID and stores it in localStorage.
 * @returns {string} A unique device identifier.
 */
function generateAndStoreDeviceId() {
  let deviceId = localStorage.getItem('uniqueDeviceId');
  if (!deviceId) {
    deviceId = generateUniqueDeviceId();
    localStorage.setItem('uniqueDeviceId', deviceId);
    console.log('Generated and stored new unique device ID:', deviceId);
  }
  return deviceId;
}

function openUploadSuccessModal() {
  const modal = document.getElementById('uploadSuccessModal');
  if (!modal) return;
  modal.style.display = 'flex';
}


/**
 * Closes the Upload Success modal.
 */
function closeUploadSuccessModal() {
  const modal = document.getElementById('uploadSuccessModal');
  if (modal) {
    modal.style.display = 'none';
    console.log('Upload Success modal closed.');
  }
}


// Initialize Event Listeners on DOM Content Loaded
// document.addEventListener('DOMContentLoaded', function() {
//   initializeEventListeners();
//   fetchAndPopulateCarousel(); // Populates the "Recent Images" carousel
//   fetchAndPopulateStyleCarousel(); // Populates the "Select Template" carousel
//   generateAndStoreDeviceId(); // Ensure device ID is stored
//   console.log('DOMContentLoaded event handled.');
// });

// Close modals when clicking outside of the modal content
window.addEventListener('click', handleWindowClick);

// Handle File Input Changes for Gallery and Camera Uploads
document.getElementById('customImageGallery')?.addEventListener('change', (event) => handleFileSelect(event, 'gallery'));
document.getElementById('customImageCamera')?.addEventListener('change', (event) => handleFileSelect(event, 'camera'));
